import * as types from '../types/supportTypes';
import * as supportServices from '../../services/supportServices';

export function fetchTickets(params) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_TICKETS_REQUEST });
    try {
      const data = await supportServices.fetchTickets(params);
      const list = Array.isArray(data) ? data : (data.tickets || data || []);
      dispatch({ type: types.FETCH_TICKETS_SUCCESS, payload: list });
    } catch (error) {
      dispatch({ type: types.FETCH_TICKETS_FAILURE, payload: error.message });
    }
  };
}

export function fetchTicketById(id) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_TICKET_BY_ID_REQUEST });
    try {
      const data = await supportServices.getTicketById(id);
      dispatch({ type: types.FETCH_TICKET_BY_ID_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_TICKET_BY_ID_FAILURE, payload: error.message });
    }
  };
}

export function createTicket(payload) {
  return async (dispatch) => {
    dispatch({ type: types.CREATE_TICKET_REQUEST });
    try {
      const data = await supportServices.createTicket(payload);
      dispatch({ type: types.CREATE_TICKET_SUCCESS, payload: data });
      return { success: true, data };
    } catch (error) {
      dispatch({ type: types.CREATE_TICKET_FAILURE, payload: error.message });
      return { success: false, error: error.message };
    }
  };
}

export function updateTicket(id, payload) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_TICKET_REQUEST });
    try {
      const data = await supportServices.updateTicket(id, payload);
      dispatch({ type: types.UPDATE_TICKET_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.UPDATE_TICKET_FAILURE, payload: error.message });
    }
  };
}

export function addTicketReply(id, message) {
  return async (dispatch) => {
    dispatch({ type: types.UPDATE_TICKET_REQUEST });
    try {
      const data = await supportServices.addTicketReply(id, message);
      dispatch({ type: types.FETCH_TICKET_BY_ID_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.UPDATE_TICKET_FAILURE, payload: error.message });
    }
  };
}

export function fetchArticles(params) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_ARTICLES_REQUEST });
    try {
      const data = await supportServices.fetchArticles(params);
      const list = Array.isArray(data) ? data : (data.articles || data || []);
      dispatch({ type: types.FETCH_ARTICLES_SUCCESS, payload: list });
    } catch (error) {
      dispatch({ type: types.FETCH_ARTICLES_FAILURE, payload: error.message });
    }
  };
}

export function fetchArticleById(id) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_ARTICLE_BY_ID_REQUEST });
    try {
      const data = await supportServices.fetchArticleById(id);
      dispatch({ type: types.FETCH_ARTICLE_BY_ID_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_ARTICLE_BY_ID_FAILURE, payload: error.message });
    }
  };
}

export function fetchForumCategories() {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_FORUM_CATEGORIES_REQUEST });
    try {
      const data = await supportServices.fetchForumCategories();
      const list = Array.isArray(data) ? data : (data.categories || data || []);
      dispatch({ type: types.FETCH_FORUM_CATEGORIES_SUCCESS, payload: list });
    } catch (error) {
      dispatch({ type: types.FETCH_FORUM_CATEGORIES_FAILURE, payload: error.message });
    }
  };
}

export function fetchForumPosts(params) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_FORUM_POSTS_REQUEST });
    try {
      const data = await supportServices.fetchForumPosts(params);
      const list = Array.isArray(data) ? data : (data.posts || data || []);
      dispatch({ type: types.FETCH_FORUM_POSTS_SUCCESS, payload: list });
    } catch (error) {
      dispatch({ type: types.FETCH_FORUM_POSTS_FAILURE, payload: error.message });
    }
  };
}

export function fetchForumPostById(id) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_FORUM_POST_BY_ID_REQUEST });
    try {
      const data = await supportServices.fetchForumPostById(id);
      dispatch({ type: types.FETCH_FORUM_POST_BY_ID_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: types.FETCH_FORUM_POST_BY_ID_FAILURE, payload: error.message });
    }
  };
}

export function createForumPost(payload) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_FORUM_POSTS_REQUEST });
    try {
      const data = await supportServices.createForumPost(payload);
      dispatch({ type: types.CREATE_FORUM_POST_SUCCESS, payload: data });
      return { success: true, data };
    } catch (error) {
      dispatch({ type: types.FETCH_FORUM_POSTS_FAILURE, payload: error.message });
      return { success: false, error: error.message };
    }
  };
}

export function createForumReply(postId, payload) {
  return async (dispatch) => {
    dispatch({ type: types.FETCH_FORUM_POST_BY_ID_REQUEST });
    try {
      const data = await supportServices.createForumReply(postId, payload);
      dispatch({ type: types.CREATE_FORUM_REPLY_SUCCESS, payload: data });
      return { success: true, data };
    } catch (error) {
      dispatch({ type: types.FETCH_FORUM_POST_BY_ID_FAILURE, payload: error.message });
      return { success: false, error: error.message };
    }
  };
}

